import { shallowRef } from "@vue/reactivity";
import { watchEffect } from "@vue/runtime-core";
import { bgText } from "@public/js/components/bg-text.js";

export class PageLoaderModel {
    loading = shallowRef(false);

    toggle = (value = !this.loading.value) => {
        this.loading.value = value;
    };

    constructor() {
        watchEffect(() => {
            if (this.loading.value) {
                // eslint-disable-next-line
                document.getElementById("body")?.classList.add("loading");
                document.documentElement.scrollTop = 0;
            } else {
                // eslint-disable-next-line
                document.getElementById("body")?.classList.remove("loading");
                document.documentElement.scrollTop = 0;
                bgText();
            }
        });
    }
}

export const pageLoaderModel = new PageLoaderModel();
